var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0973 8.24528V6.2327M12.0973 8.24528C12.0973 8.35644 12.0102 8.44654 11.9027 8.44654H6.45133C6.3438 8.44654 6.25664 8.35644 6.25664 8.24528V6.2327C6.25664 5.34349 6.95396 4.62264 7.81416 4.62264H10.5398C11.4 4.62264 12.0973 5.34349 12.0973 6.2327M12.0973 8.24528C12.0973 8.35644 12.1845 8.44654 12.292 8.44654H17.7434C17.8509 8.44654 17.9381 8.35644 17.9381 8.24528V6.2327C17.9381 5.34349 17.2407 4.62264 16.3805 4.62264H13.6549C12.7947 4.62264 12.0973 5.34349 12.0973 6.2327M3.14159 14.8868V17M20.8584 14.8868V17M1.19469 14.8868H22.8053C22.9128 14.8868 23 14.7967 23 14.6855V10.6604C23 9.43771 22.0412 8.44654 20.8584 8.44654H3.14159C1.95882 8.44654 1 9.43771 1 10.6604V14.6855C1 14.7967 1.08717 14.8868 1.19469 14.8868ZM3.33628 8.44654H20.6637C20.7712 8.44654 20.8584 8.35644 20.8584 8.24528V2.61006C20.8584 1.72085 20.1611 1 19.3009 1H4.69911C3.83892 1 3.14159 1.72085 3.14159 2.61006V8.24528C3.14159 8.35644 3.22876 8.44654 3.33628 8.44654Z",
    stroke: "white",
    strokeWidth: 1.75,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBed);
export default __webpack_public_path__ + "static/media/Bed.c5ab5665db0805c53bcf16036404cf0e.svg";
export { ForwardRef as ReactComponent };